export const User_URL = '/user/';
export const API_URL = '/auth/';
export const Lead_URL = '/lead/';
export const Business_URL = '/user/business/';
export const Campaign_URL = '/user/campaign/';
export const Integration_URL = '/user/integrations';
export const Dashboard_URL = '/dashboard/';
